export const SIGNATURE_REDUCER_NAME = 'signature';
export const DOSSIER_SIGNATURE_SLICE_NAME = 'dossierSignature';
export const DEMANDEUR_SIGNATURE_SLICE_NAME = 'demandeurSignature';
